import api from '@/api/api'
// import { schema } from 'normalizr'

export default {
  strict: false,
  namespaced: true,
  state: {
    configuracion: {},
    tiposSolicitud: [],
    modulosPortalCliente: [],
    oficioAltaSolitudes: false,
    tipoDatosColumnCode: [],
    estructuraDescargaDocumentos: [],
    promocionesTiposVisita: [],
    promocionesTiposVisitaWeb: [],
    promocionesTiposSolicitudCliente: [],
    promocionesTiposSolicitudClienteWeb: [],
    tiposSolicitudCliente: [],
    tiposSolicitudClienteWeb: []
  },
  mutations: {
    set (state, payload) {

      let tiposVisitaConfiguracion = payload.PV_TIPO_VISITA || ''

      const campos = payload.PV_CAMPOS_INCIDENCIA.split('|').filter(x => x !== '')
      const tiposVisita = tiposVisitaConfiguracion.split('|').filter(x => x !== '')

      const origenInci = [] //payload.PV_PDC_POR_ORIGEN.split('|').filter(x => x !== '')
      const origenInciWeb = [] //payload.PV_PDC_POR_ORIGEN.split('|').filter(x => x !== '')
      const estadoInci = [] // payload.PV_PDC_POR_ESTADO.split('|').filter(x => x !== '')
      const estadoInciWeb = [] // payload.PV_PDC_POR_ESTADO.split('|').filter(x => x !== '')
      const tipoVisitInci = payload.PV_PDC_TIPOS_VISITA_INCIDENCIA.split('|').filter(x => x !== '')
      const tipoVisitInciWeb = (payload.PV_WEB_PDC_TIPOS_VISITA_INCIDENCIA || '').split('|').filter(x => x !== '')
      const tiposVisitaEmailAutomatico = payload.PV_TIPO_VISITA_MAIL_AUTOMATICO || ''
      const desdeTerminadoWeb = (!(payload.PV_WEB_CIERRE_CLIENTE === 'S') && (payload.PV_WEB_PDC_CLIENTE_CERRAR_INCIDENCIAS === 'S' || payload.PV_WEB_PDC_CLIENTE_RECHAZA_INCIDENCIAS === 'S'))

      state.configuracion = {
        camposIncidencia: campos,
        camposObligatorios: payload.PV_CAMPOS_OBLIGATORIOS.split('|').filter(x => (campos.includes(x) && x !== '')),
        emailProveedor: payload.PV_CUERPO_EMAIL_PARTE_PROVEEDOR,
        diasRegistroCierre: payload.PV_DIAS_FECHA_PREVISTA,
        permitirEnvioMasivo: payload.PV_ENVIO_MASIVO_PARTES === 'S',
        mostrarObservacionesParteMono: payload.PV_MOSTRAR_OBSERVACIONES_PARTE === 'S',
        envioEmailAutomatico: payload.PV_MAIL_AUTOMATICO_ALTA === 'S',
        maxIncidenciasFicha: payload.PV_NUM_MAX_INCIDENCIAS_FICHA,
        mostrarOficio: payload.PV_PDC_OFICIO_EN_ALTA === 'S',
        mostrarOficioWeb: payload.PV_WEB_PDC_OFICIO_EN_ALTA === 'S',
        mostrarObservaciones: payload.PV_PDC_MOSTRAR_OBSERVACIONES === 'S',
        mostrarObservacionesEstados: (payload.PV_PDC_MOSTRAR_OBSERVACIONES_ESTADOS !== undefined) ? payload.PV_PDC_MOSTRAR_OBSERVACIONES_ESTADOS.split('|').filter(x => x !== '') : null,
        mostrarObservacionesWeb: payload.PV_WEB_PDC_MOSTRAR_OBSERVACIONES === 'S',
        configVistoBuenoCliente: payload.PV_CIERRE_CLIENTE === 'S',
        configVistoBuenoClienteWeb: payload.PV_WEB_CIERRE_CLIENTE === 'S',
        permitirIncidenciasRechazado: payload.PV_PERMITIR_ALTA_INCIDENCIA_RECHAZADA === 'S',
        tiposIncidenciaAlquiler: payload.PV_TIPO_INCIDENCIA_ALQ.split('|').filter(x => x !== ''),
        tiposIncidenciaSinOperacion: payload.PV_TIPO_INCIDENCIA_SIN_OPER.split('|').filter(x => x !== ''),
        tiposIncidenciaVenta: payload.PV_TIPO_INCIDENCIA_VTA.split('|').filter(x => x !== ''),
        tiposVisita: tiposVisita,
        tiposVisitaEmailAutomatico: tiposVisitaEmailAutomatico.split('|').filter(x => (tiposVisita.includes(x) && x !== '')),
        transitoLibreEstados: payload.PV_TRANSITO_LIBRE_ESTADOS === 'S',
        diasCierre: payload.PV_DIAS_DESDE_CIERRE,
        diasCierreWeb: payload.PV_WEB_DIAS_DESDE_CIERRE,
        asignarProveedorAuto: payload.PV_ASIGNAR_SI_PROVEEDOR_UNICO === 'S',
        descargaImagenesPrimeraIncidencia: payload.PV_OMITIR_IMAGENES_PRIMERA_SINCRONIZACION === 'S',
        proveedorVisitador: payload.PV_PROVEEDOR_VISITADOR === 'S',
        visualizarFiltroEvaluado: payload.PV_VISUALIZAR_FILTRO_EVALUADO === 'S',
        obligatorioAdjuntarImgAltaSolicitud: payload.PV_OBLIGATORIO_ADJUNTAR_IMAGEN_ALTA_SOLICITUD === 'S',
        permitirAsignarPromocionesProveedor: payload.PV_PERMITIR_ASIGNAR_PROMOCIONES_PROVEEDOR === 'S',
        generarParteAlta: payload.PV_GENERAR_PARTE_ALTA === 'S',
        permitirCierreProveedorVisitador: payload.PV_PERMITIR_CIERRE_ROVEEDOR_VISITADOR === 'S',
        obligatorioIncorporarDatosClienteCierre: payload.PV_INCORPORAR_DATOS_CLIENTE_CIERRE === 'S',
        descripcionTextoConformidad: payload.PV_DESCRIPCION_TEXTO_CONFORMIDAD,
        permitirChat: payload.PV_PERMITIR_CHAT === 'S',
        clienteCrearIncidencias: payload.PV_PDC_CLIENTE_CREAR_INCIDENCIAS === 'S',
        clienteCrearIncidenciasWeb: payload.PV_WEB_PDC_CLIENTE_CREAR_INCIDENCIAS === 'S',
        clientesVer: payload.PV_PDC_CLIENTE_VER_INCIDENCIAS === 'S',
        clientesVerWeb: payload.PV_WEB_PDC_CLIENTE_VER_INCIDENCIAS === 'S',
        clientesRechazar: payload.PV_PDC_CLIENTE_RECHAZA_INCIDENCIAS === 'S',
        clientesRechazarWeb: payload.PV_WEB_PDC_CLIENTE_RECHAZA_INCIDENCIAS === 'S',
        clientesCerrar: payload.PV_PDC_CLIENTE_CERRAR_INCIDENCIAS === 'S',
        clientesCerrarWeb: payload.PV_WEB_PDC_CLIENTE_CERRAR_INCIDENCIAS === 'S',
        clienteEditarSolicitudes: payload.PV_PDC_CLIENTE_EDITA_INCIDENCIAS === 'S',
        clienteEditarSolicitudesNoEvaluadas: payload.PV_PDC_CLIENTE_EDITA_INCIDENCIAS_NO_EVALUADAS === 'S',
        clienteEditarSolicitudesEditarFotosGuardadas: payload.PV_PDC_CLIENTE_EDITA_INCIDENCIAS_EDITAR_FOTOS_GUARDADAS === 'S',
        clienteEditarSolicitudesBorrarIncidencia: payload.PV_PDC_CLIENTE_EDITA_INCIDENCIAS_BORRAR_INCIDENCIA === 'S',
        origenIncidencia: origenInci,
        origenIncidenciaWeb: origenInciWeb,
        estadoIncidencia: estadoInci,
        estadoIncidenciaWeb: estadoInciWeb,
        tipoVisitaIncidencia: tipoVisitInci,
        tipoVisitaIncidenciaWeb: tipoVisitInciWeb,
        diasVisibleCliente: payload.PV_PDC_CLIENTE_DIAS_VISIBLE,
        diasVisibleClienteWeb: payload.PV_WEB_CLIENTE_DIAS_VISIBLE,
        ocultarProveedorHoras: payload.PV_WEB_OCULTAR_PROVEEDOR_HORAS === 'S',
        ocultarResponsable: payload.PV_WEB_OCULTAR_RESPONSABLE === 'S',
        desdeTerminadoWeb: desdeTerminadoWeb,
        codigoPropioNombre: payload.PV_CODIGO_PROPIO_NOMBRE,
        PV_LIMITE_SOLICITUDES: payload.PV_LIMITE_SOLICITUDES,
        PV_DIRECCION_DATOS_IDENTIFICACION: payload.PV_DIRECCION_DATOS_IDENTIFICACION === 'S',
        PV_PERMITIR_BORRAR_MAESTROS_CON_INCI: payload.PV_PERMITIR_BORRAR_MAESTROS_CON_INCI === 'S',
        PV_PDC_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR: payload.PV_PDC_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR === 'S',
        PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR: payload.PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR === 'S',
        PV_APP_ENVIO_RESUMEN_SUPERVISOR: payload.PV_APP_ENVIO_RESUMEN_SUPERVISOR === 'S',
        PV_WEB_ENVIO_RESUMEN_SUPERVISOR: payload.PV_WEB_ENVIO_RESUMEN_SUPERVISOR === 'S',
        PV_ACTIVAR_ENCUESTA: payload.PV_ACTIVAR_ENCUESTA === 'S',
        PV_INFORME_NOTAS: payload.PV_INFORME_NOTAS === 'S',
        PV_INFORME_OBSERVACIONES: payload.PV_INFORME_OBSERVACIONES === 'S',
        PV_VISITA_FECHA_ALTA_CLIENTE: payload.PV_VISITA_FECHA_ALTA_CLIENTE === 'S',
        PV_VISITA_REGISTRO_ENTRADA: payload.PV_VISITA_REGISTRO_ENTRADA === 'S',
        PV_RESTRINGIR_NOTAS_A_PROVEEDORES: payload.PV_RESTRINGIR_NOTAS_A_PROVEEDORES === 'S',
        PV_MAIL_DESCRIPCION: payload.PV_MAIL_DESCRIPCION === 'S',
        PV_MAIL_DATOS_CLIENTE: payload.PV_MAIL_DATOS_CLIENTE === 'S',
        PV_TEXTO_PIE_RESUMEN: payload.PV_TEXTO_PIE_RESUMEN,
        bloquearChatCerradas: payload.PV_WEB_PDC_BLOQUEAR_CHAT_INCIDENCIAS_CERRADAS === 'S',
        PV_BLOQUEO_CAMPO_DESCRIPCION_CLIENTE: payload.PV_BLOQUEO_CAMPO_DESCRIPCION_CLIENTE === 'S',
        PV_BLOQUEO_CAMPO_DESCRIPCION_WEB: payload.PV_BLOQUEO_CAMPO_DESCRIPCION_WEB === 'S',
        PV_PERMISOS_EXTRA_PROVEEDOR: payload.PV_PERMISOS_EXTRA_PROVEEDOR === 'S',
        PV_IMPORTACION_CERRADAS: payload.PV_IMPORTACION_CERRADAS == null || payload.PV_IMPORTACION_CERRADAS === 'S',
        PV_TRANSITO_ESTADOS_PROVEEDOR: payload.PV_TRANSITO_ESTADOS_PROVEEDOR === 'S',
        PV_ALTA_ACTOR_PROVEEDOR: payload.PV_ALTA_ACTOR_PROVEEDOR === 'S',
      }
    },
    setTiposSolicitudes (state, payload) {
      // state.tiposSolicitud =
      state.tiposSolicitud = payload.data.tiposSolicitud.map(e => {
        return {
          idtipoSolicitud: e.idTipoSolicitud,
          codigoTipoSolicitud: e.codigoTipoSolicitud,
          descripcionTipoSolicitud: e.descripcionTipoSolicitud,
          translates: e.translates,
          habilitar: (e.eshabilitado === '1'),
          habilitarCliente: (e.esHabilitadoCliente === '1'),
          habilitarClienteWeb: (e.esHabilitadoClienteWeb === '1')
        }
      })
    },
    setPromocionesTiposVisita (state, payload) {
      state.promocionesTiposVisita = payload.data
    },
    setPromocionesTiposVisitaWeb (state, payload) {
      state.promocionesTiposVisitaWeb = payload.data
    },
    setPromocionesTiposSolicitudCliente (state, payload) {
      state.promocionesTiposSolicitudCliente = payload.data
    },
    setPromocionesTiposSolicitudClienteWeb (state, payload) {
      state.promocionesTiposSolicitudClienteWeb = payload.data
    },
    setTiposSolicitudesCliente (state, payload) {
      state.tiposSolicitudCliente = payload.data
    },
    setTipoDatosColumna(state, payload) {
      state.tipoDatosColumnCode[payload.tableName] = payload.dataType
    },
    setModulosPortalCliente (state, payload) {
      state.modulosPortalCliente = payload.data.map(e => {
        return {
          codigo: e.codigo,
          descripcion: e.descripcion
        }
      })
    },
    setEstructuraDescargaDocumentos (state, payload) {
      state.estructuraDescargaDocumentos = payload.data
    }
  },
  actions: {
    obtenerConfiguracion ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/obtenerConfiguracion', {
          credentials: rootState.login.credentials
        }).then(response => {
          /*
          // 283946 - Esto no es necesario, la config de PV se mantiene y se añade la del portal de admin
          
          try {
            let permisosActor = rootState.login.idubapi.PERMISOS_ACTOR_VISITAS_PV;
            response.data.PV_TIPO_INCIDENCIA_VTA = permisosActor.PV_TIPO_INCIDENCIA_VTA;
            response.data.PV_TIPO_INCIDENCIA_ALQ = permisosActor.PV_TIPO_INCIDENCIA_ALQ;
            response.data.PV_TIPO_INCIDENCIA_SIN_OPER = permisosActor.PV_TIPO_INCIDENCIA_SIN_OPER;
          } catch (error) {
            console.log("Error Permisos Actor Visitas PV: ",error)
          }
          */
          localStorage.setItem('configuracion', JSON.stringify(response.data))
          commit('set', response.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarConfiguracion ({ rootState }, objeto) {
      console.log("guardarConfiguracion")
      console.log(objeto)
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarConfiguracion', {
          credentials: rootState.login.credentials,
          values: objeto
        }).then(() => {
          // localStorage.setItem('configuracion', JSON.stringify(response.data))
          // commit('set', response.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarIdiomaUsuario ({ rootState }, idioma) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarIdiomaUsuario', {
          credentials: rootState.login.credentials,
          values: idioma
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarConfiguracionInicial({ rootState }) {
      const objeto = {
        PV_DIRECCION_DATOS_IDENTIFICACION: 'N',
        PV_PERMITIR_BORRAR_MAESTROS_CON_INCI: 'S'
      }
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarConfiguracionInicial', {
          credentials: rootState.login.credentials,
          values: objeto
        }).then(() => {
          // localStorage.setItem('configuracion', JSON.stringify(response.data))
          // commit('set', response.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerTiposSolicitud ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        api.post('/solicitudes/getTiposSolicitud', {
          credentials: rootState.login.credentials
        }).then(response => {
          if(response.data.data.result === 'NOK')
          {
            reject({
              message: response.data.data.descriptionNOK.replace('<br><br>', '')
            })
          }

          commit('setTiposSolicitudes', response.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarTraduccionesPorDefecto ({ rootState }) {
      return new Promise((resolve, reject) => {
        api.post('/translate/guardarTraduccionesPorDefecto', {
          credentials: rootState.login.credentials
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    delPromotionsProvider ({ rootState }) {
      return new Promise((resolve, reject) => {
        api.post('/promotion/delPromotionsProvider', {
          credentials: rootState.login.credentials
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarTiposSolicitudes ({ rootState }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/solicitudes/guardarTiposSolicitud', {
          credentials: rootState.login.credentials,
          values: objeto
        }).then(() => {
          // localStorage.setItem('configuracion', JSON.stringify(response.data))
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarEstructuraDescargaDocumentos ({ rootState }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarEstructuraDescargaDocumentos', {
          credentials: rootState.login.credentials,
          values: objeto
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarTiposSolicitudesCliente ({ rootState }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarTiposSolicitudesCliente', {
          credentials: rootState.login.credentials,
          values: objeto,
          tipo: 'APP'
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarPromocionesTiposVisita ({ rootState }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarPromocionesTiposVisita', {
          credentials: rootState.login.credentials,
          values: objeto,
          tipo: 'APP'
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarPromocionesTiposVisitaWeb ({ rootState }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarPromocionesTiposVisita', {
          credentials: rootState.login.credentials,
          values: objeto,
          tipo: 'WEB'
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerPromocionesTiposVisita ({ commit, rootState }, tipo) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/obtenerPromocionesTiposVisita', {
          credentials: rootState.login.credentials,
          tipo: tipo
        }).then((response) => {
          if (tipo === 'APP') {
            commit('setPromocionesTiposVisita', response.data)
          } else {
            commit('setPromocionesTiposVisitaWeb', response.data)
          }
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerPromocionesTiposSolicitudCliente ({ commit, rootState }, tipo) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/obtenerPromocionesTiposSolicitud', {
          credentials: rootState.login.credentials,
          tipo: tipo
        }).then((response) => {
          if (tipo === 'APP') {
            commit('setPromocionesTiposSolicitudCliente', response.data)
          } else {
            commit('setPromocionesTiposSolicitudClienteWeb', response.data)
          }
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarPromocionesTiposSolicitudCliente ({ rootState }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarPromocionesTiposSolicitud', {
          credentials: rootState.login.credentials,
          values: objeto,
          tipo: 'APP'
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    guardarPromocionesTiposSolicitudClienteWeb ({ rootState }, objeto) {
      return new Promise((resolve, reject) => {
        api.post('/configuracion/guardarPromocionesTiposSolicitud', {
          credentials: rootState.login.credentials,
          values: objeto,
          tipo: 'WEB'
        }).then(() => {
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerModulosPortalCliente({commit, rootState}) {
      return new Promise((resolve, reject) => {
        api.post('/sic/getModulos', {
          credentials: rootState.login.credentials
        }).then(response => {
          commit('setModulosPortalCliente', response.data)
          resolve()
        })
          .catch(e => {
            reject(e)
          })
      })
    },
    // obtenerOficioAltaSolicitudes({commit, rootState}) {
    //   return new Promise((resolve, reject) => {
    //     api.post('sic/getOficioAltaSolicitudes', {
    //       credentials: rootState.login.credentials
    //     })
    //       .then(response => {
    //         commit('setOficioAltaSolicitudes', response.data)
    //         resolve()
    //       })
    //       .catch(e => {
    //         reject(e)
    //       })
    //   })
    // },
    obtenerEstructuraDescargaDocumentos({commit, rootState}) {
      return new Promise((resolve, reject) => {
        api.post('configuracion/obtenerEstructuraDescargaDocumentos', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            commit('setEstructuraDescargaDocumentos', response.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerTipoDatosColumna({commit, rootState}, object) {
      let tableName = object.table
      return new Promise((resolve, reject) => {
        api.post('configuracion/obtenerTipoDatosColumna', {
          credentials: rootState.login.credentials,
          values: {
            tableName: object.table,
            columnName: object.column
          }
        })
          .then(response => {
            let setData = {
              tableName: tableName,
              'dataType': response.data.trim()
            }

            commit('setTipoDatosColumna', setData)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getConfiguracion (state) {
      return state.configuracion
      // return Object.keys(state.configuracion).map(id => state.list[id])
    },
    getTiposSolicitud (state, getters, rootState) {
      return state.tiposSolicitud.filter(x => {
        return rootState.login.idubapi.tiposSolicitudes.includes(x.codigoTipoSolicitud) && x.habilitar
      })
    },
    getAllTiposSolicitud (state) {
      return state.tiposSolicitud
    },
    getModulosPortalCliente (state) {
      return state.modulosPortalCliente
    },
    getOficioAltaSolicitudes (state) {
      return state.oficioAltaSolitudes
    },
    getEstructuraDescargaDocumentos (state) {
      return state.estructuraDescargaDocumentos
    },
    getPromocionesTiposVisita (state) {
      return state.promocionesTiposVisita
    },
    getPromocionesTiposVisitaWeb (state) {
      return state.promocionesTiposVisitaWeb
    },
    getPromocionesTiposSolicitudCliente (state) {
      return state.promocionesTiposSolicitudCliente
    },
    getPromocionesTiposSolicitudClienteWeb (state) {
      return state.promocionesTiposSolicitudClienteWeb
    },
    getTiposSolicitudCliente (state) {
      return state.tiposSolicitudCliente
    },
    getTiposSolicitudClienteWeb (state) {
      return state.tiposSolicitudClienteWeb
    },
  }
}
